<template>
  <nav
    class="top-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-white shadow"
  >
    <div
      class="container px-4 mx-auto flex flex-wrap items-center justify-between"
    >
      <div
        class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start"
      >
        <a class="text-3xl font-semibold leading-none" to="/">
          <img
            class="h-12 w-12"
            src="/metis-assets/logos/metis/metis.webp"
            alt="localgps Logo"
          />
        </a>
        <button
          class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
          type="button"
          v-on:click="setNavbarOpen"
        >
          <font-awesome-icon :icon="['fas', 'bars']" />
        </button>
      </div>
      <div
        class="lg:flex flex-grow items-center"
        :class="[navbarOpen ? 'block' : 'hidden']"
      >
        <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
          <li
            v-for="(route, index) in navRoutes"
            :key="index"
            class="px-3 py-4 lg:py-2 flex items-center text-normal font-semi-bold"
          >
            <a :href="route.link"> {{ route.name }} </a>
          </li>

          <li>
            <div id="search"></div>
          </li>
          <li class="flex items-center">
            <button
              class="text-white text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
              type="button"
              style="background-color: #03989e"
            >
              <a href="/search">Search</a>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: ["navRoutes"],
  data() {
    return {
      navbarOpen: false,
    };
  },
  methods: {
    setNavbarOpen() {
      this.navbarOpen = !this.navbarOpen;
    },
  },
  components: {},
};
</script>
